<template>
  <div>
    <Modal v-model="setAgentComModal" width="600" footer-hide>
      <p slot="header" class="text-center">分配代理商</p>
      <div>
        <div class="m-b-10">
          <Button type="primary" size="small" :disabled="selectedComArray.length===0||!this.dateTimes||this.dateTimes.length===0" @click="onConfirmSet">确认分配</Button>
        </div>
        <div class="m-b-10">
          <DatePicker v-model="dateTimes" size="small" type="datetimerange" placeholder="选择开始结束时间" style="width: 100%" @on-change="onChangeDates"></DatePicker>
          <div class="text-orange">
            说明：请填写开始时间和结束时间
          </div>
        </div>
        <Table size="small" stripe :max-height="700" :data="list" :columns="tableColumns" :loading="tableLoading"
          @on-selection-change="onSelection"></Table>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getProjectCompany } from '@/api/os/project'
import { setCompanySku } from '@/api/product/productskuedit'
export default {
  props: {
    projectId: {
      type: Number,
      required: true
    },
    selectedSkuIds: [Array],
    onSuccess: [Function]
  },
  data () {
    return {
      setAgentComModal: false,
      tableLoading: false,
      list: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '公司名称', align: 'center', key: 'name' }
      ],
      dateTimes: [],
      availableEndTime: '',
      availableStartTime: '',
      selectedComArray: []
    }
  },
  methods: {
    showModal () {
      this.getComData()
      this.dateTimes = []
      this.setAgentComModal = true
    },
    async getComData () {
      this.tableLoading = true
      const query = {
        projectId: this.projectId,
        type: 3 // 3：代理商；5：供应商
      }
      const result = await getProjectCompany(query).finally(() => { this.tableLoading = false })
      this.list = (result && !result.errcode) ? result : []
    },
    onChangeDates (dates) {
      this.dateTimes = dates
      this.availableStartTime = dates[0]
      this.availableEndTime = dates[1]
    },
    onSelection (selections) {
      this.selectedComArray = selections.map(x => x.id)
    },
    onConfirmSet () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确认分配代理商？',
        onOk: async () => {
          const postData = {
            availableStartTime: this.availableStartTime,
            availableEndTime: this.availableEndTime,
            companyIds: JSON.stringify(this.selectedComArray),
            skuIds: JSON.stringify(this.selectedSkuIds)
          }
          const result = await setCompanySku(postData)
          if (result && result.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.selectedComArray = []
            this.setAgentComModal = false
            this.onSuccess()
          }
        }
      })
    }
  }
}
</script>
